module.exports = __webpack_public_path__ + "img/folder.a79fa657.png";